import styled from 'styled-components';

export const Wrapper = styled.div`
  position: fixed;
  inset: 0;

  display: flex;
  justify-content: center;
  align-items: center;
  padding: 25vh 25vw;
  padding: 25dvh 25dvw;
  background: var(--primary);
`;

export const Image = styled.img`
  width: 192px;
  height: 192px;
  position: absolute;
  top: 33%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
